import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as snackbarActions from "../../../actions/snackbarActions";
import BaseGynObsReport from "./BaseGynObsReport";

const MaternityRegisterReport = ({ actions }) => (
  <BaseGynObsReport
    title="Maternity Register Report"
    endpoint="obgyn/reports/maternity-register"
    actions={actions}
    columns={[
      { key: "delivery_datetime", label: "Delivery Date/Time" },
      { key: "patient_number", label: "Patient No." },
      { key: "patient_name", label: "Patient Name" },
      { key: "phone_no", label: "Phone" },
      { key: "delivery_mode", label: "Delivery Mode" },
      { key: "number_of_babies", label: "Babies" },
      { key: "maternal_condition_post_delivery", label: "Maternal Condition" },
    ]}
  />
);

const mapDispatchToProps = (dispatch) => ({
  actions: {
    snackbarActions: bindActionCreators(snackbarActions, dispatch),
  },
});

export default connect(null, mapDispatchToProps)(MaternityRegisterReport);
